export const fields = `
	"url": asset->url
`

export const fragment = name => {
  return `${name}{
		${fields}
	}`
}

const exports = { fields, fragment }

export default exports
